import { configureStore } from '@reduxjs/toolkit';

import uiSlice from './ui-slice';
import appConfigSlice from './appConfig-slice';
import landingPageSlice from './forms/landing-page-slice';
import form2Slice from './forms/form2-slice';
import form3Slice from './forms/form3-slice';
import form4Slice from './forms/form4-slice';
import form5Slice from './forms/form5-slice';
import form6Slice from './forms/form6-slice';
import form7Slice from './forms/form7-slice';
import formEndingSlice from './forms/formEnding-slice';
import catalogsSlice from './catalogs-slice';

const reduxStore = configureStore({
  reducer: {
    ui: uiSlice.reducer,
    appConfig: appConfigSlice.reducer,
    catalogs: catalogsSlice.reducer,
    landingPage: landingPageSlice.reducer,
    form2: form2Slice.reducer,
    form3: form3Slice.reducer,
    form4: form4Slice.reducer,
    form5: form5Slice.reducer,
    form6: form6Slice.reducer,
    form7: form7Slice.reducer,
    formEnding: formEndingSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      // Ignore these field paths in all actions
      ignoredActionPaths: ['payload.buttonAction'],
      // Ignore these paths in the state
      ignoredPaths: [
        'ui.processStatus.buttonAction',
        'ui.confirmStatus.buttonAction',
      ],
    },
  }),
});

export default reduxStore;
